export const testimonials = [
  {
    name: "Priya Sharma",
    role: "Parent of Aanya (Nursery)",
    rating: 5,
    text: "Happykidz Preschool has been a wonderful experience for our daughter. The teachers are incredibly caring and the curriculum is world-class. Aanya loves going to school every day and comes home with new things to share!",
    avatar: "https://i.pravatar.cc/100?img=1"
  },
  {
    name: "Rajesh Kumar",
    role: "Parent of Arjun (Kindergarten)",
    rating: 5,
    text: "The transformation in my son has been incredible. He's become more confident, creative, and socially aware. The staff truly goes above and beyond for every child. Couldn't ask for better educators.",
    avatar: "https://i.pravatar.cc/100?img=3"
  },
  {
    name: "Sunita Patel",
    role: "Parent of Riya (Playgroup)",
    rating: 5,
    text: "From the moment we walked in, we felt the warmth and professionalism. The facilities are excellent and the approach to learning is exactly what we were looking for. Highly recommend Happykidz Preschool!",
    avatar: "https://i.pravatar.cc/100?img=5"
  },
  {
    name: "Vikram Mishra",
    role: "Parent of Aditya (Pre-KG)",
    rating: 5,
    text: "My son Aditya has grown so much in just one year at Happykidz. His language skills, creativity, and social abilities have improved tremendously. The teachers really know each child personally.",
    avatar: "https://i.pravatar.cc/100?img=7"
  },
  {
    name: "Meera Nair",
    role: "Parent of Kavya (Kindergarten)",
    rating: 5,
    text: "Happykidz is the best decision we made for our daughter. The balanced approach between play and learning is exactly right for her age. She's excited about school every morning!",
    avatar: "https://i.pravatar.cc/100?img=9"
  },
  {
    name: "Suresh Behera",
    role: "Parent of Rohan (After School)",
    rating: 5,
    text: "The after-school program is fantastic. Rohan is always engaged, doing homework under supervision and then enjoying fun activities. It's a relief knowing he's in safe, capable hands every afternoon.",
    avatar: "https://i.pravatar.cc/100?img=11"
  },
  {
    name: "Anita Dash",
    role: "Parent of Shreya (Nursery)",
    rating: 5,
    text: "The communication from the school is excellent. We always know what Shreya is learning and how she's progressing. The parent-teacher meets are thorough and truly helpful.",
    avatar: "https://i.pravatar.cc/100?img=25"
  },
  {
    name: "Deepak Mohanty",
    role: "Parent of Aryan (Kindergarten)",
    rating: 5,
    text: "Outstanding school with a genuine focus on each child's individual development. Aryan has learned to read and write well before primary school. The faculty is exceptional.",
    avatar: "https://i.pravatar.cc/100?img=13"
  },
  {
    name: "Rekha Sahu",
    role: "Parent of Diya (Playgroup)",
    rating: 5,
    text: "As a first-time parent, I was anxious about sending my little one to school. Happykidz Preschool put all my worries to rest. The staff is nurturing, patient, and genuinely invested in each child's happiness.",
    avatar: "https://i.pravatar.cc/100?img=29"
  }
];
